/**
 * Deduplicación de mensajes compartida entre instancias de socket.
 *
 * Usa un Set con TTL implícito por tamaño máximo para evitar
 * que crezca indefinidamente en sesiones largas.
 */

const MAX_SIZE = 500;
const seenIds = new Set();

export const isMessageDuplicate = (message) => {
    const id = message?.id || message?._id;
    if (!id) return false;
    if (seenIds.has(id)) return true;

    seenIds.add(id);

    // Limpiar la mitad más antigua cuando se alcanza el límite
    if (seenIds.size > MAX_SIZE) {
        const entries = seenIds.values();
        for (let i = 0; i < MAX_SIZE / 2; i++) {
            seenIds.delete(entries.next().value);
        }
    }

    return false;
};
